import {Show} from 'platform/foundation';

import type {RefObject} from 'react';

import {DEFAULT_COL_WIDTH} from '../../constants/defaultColWidth';
import {SELECTION_COLUMN_WIDTH} from '../../constants/selectionColumn';
import type {EagColumnState} from '../../types/EagColumnState';

type TableColgroupProps = {
  colgroupRef: RefObject<HTMLTableColElement | null>;
  hasCheckboxColumn: boolean;
  nonRightPinnedColumnStates: EagColumnState[];
  rightPinnedColumnStates: EagColumnState[];
  actionColumnWidth: number;
};

export function TableColgroup(props: TableColgroupProps) {
  return (
    <colgroup ref={props.colgroupRef}>
      {/* checkbox pseudo-column: not part of columnStates, fixed width */}
      <Show when={props.hasCheckboxColumn}>
        <col style={{width: SELECTION_COLUMN_WIDTH}} />
      </Show>
      {/* left-pinned + unpinned columns */}
      {props.nonRightPinnedColumnStates.map((colState) => (
        <col key={colState.key} style={{width: colState.width ?? DEFAULT_COL_WIDTH}} />
      ))}
      {/* filler col: absorbs remaining space between unpinned and right-pinned columns.
          Positioned here so right-pinned columns naturally sit at the table's right edge
          regardless of horizontal overflow. */}
      <col />
      {/* right-pinned columns */}
      {props.rightPinnedColumnStates.map((colState) => (
        <col key={colState.key} style={{width: colState.width ?? DEFAULT_COL_WIDTH}} />
      ))}
      {/* action column col: fixed width, not resizable */}
      <Show when={props.actionColumnWidth > 0}>
        <col style={{width: props.actionColumnWidth}} />
      </Show>
    </colgroup>
  );
}
